import React from "react";
import { Link } from "react-router-dom";
import * as PhosphorIcons from "@phosphor-icons/react";
import { ArrowUpRight, Phone } from "@phosphor-icons/react";
import Layout from "@/components/site/Layout";
import { services } from "@/data/services";

export default function ServicesIndex() {
  return (
    <Layout>
      <section
        data-testid="services-index"
        className="bg-[#F4F4EB] pt-20 md:pt-28 pb-24 md:pb-32 border-b border-[#C4C4B5]"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
            <div className="max-w-3xl">
              <div className="uppercase text-xs tracking-[0.25em] font-bold text-[#E5231A] mb-4">
                Our Services
              </div>
              <h1
                data-testid="services-index-heading"
                className="font-display font-black uppercase tracking-tighter text-[#111110] text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.9]"
              >
                Everything We Do —
                <br />
                <span className="text-[#E5231A]">Under One Roof.</span>
              </h1>
              <p className="mt-6 text-base md:text-lg text-[#595955] leading-relaxed max-w-2xl">
                Sixteen services covering dirt work, fencing, trees, outdoor
                construction, concrete, hauling and heavy equipment service. One
                owner-operator, one crew, one phone number.
              </p>
            </div>
            <a
              href="tel:+13255133501"
              data-testid="services-index-call"
              className="btn-hard inline-flex items-center gap-2 bg-[#111110] text-[#F4F4EB] font-bold uppercase text-sm tracking-wider px-6 py-4 border border-[#111110] self-start"
            >
              <Phone size={18} weight="fill" />
              (325) 513-3501
            </a>
          </div>

          <div
            data-testid="services-index-grid"
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border border-[#C4C4B5] bg-[#C4C4B5] gap-px"
          >
            {services.map((s) => {
              const Icon = PhosphorIcons[s.icon] || PhosphorIcons.Wrench;
              return (
                <Link
                  key={s.slug}
                  to={`/services/${s.slug}`}
                  data-testid={`services-index-card-${s.slug}`}
                  className="group bg-[#F4F4EB] hover:bg-[#111110] transition-colors duration-150 p-7 flex flex-col gap-5 min-h-[240px]"
                >
                  <div className="flex items-start justify-between">
                    <div className="w-12 h-12 border border-[#111110] flex items-center justify-center bg-[#EAEAE0] group-hover:bg-[#E5231A] group-hover:border-[#E5231A] transition-colors">
                      <Icon
                        size={24}
                        weight="duotone"
                        className="text-[#111110] group-hover:text-[#F4F4EB] transition-colors"
                      />
                    </div>
                    <ArrowUpRight
                      size={20}
                      weight="bold"
                      className="text-[#111110] opacity-0 group-hover:opacity-100 group-hover:text-[#E5231A] transition-opacity"
                    />
                  </div>
                  <div>
                    <h3 className="font-display font-extrabold uppercase tracking-tight text-lg md:text-xl text-[#111110] group-hover:text-[#F4F4EB] transition-colors">
                      {s.name}
                    </h3>
                    <p className="mt-3 text-sm text-[#595955] group-hover:text-[#F4F4EB]/70 transition-colors leading-relaxed">
                      {s.short}
                    </p>
                  </div>
                  <span className="mt-auto pt-2 text-[11px] uppercase tracking-[0.25em] font-bold text-[#E5231A] group-hover:text-[#F4F4EB] transition-colors">
                    View details →
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </Layout>
  );
}
